import { render, staticRenderFns } from "./PaymentMethodDetails.vue?vue&type=template&id=4ea84b1b&"
import script from "./PaymentMethodDetails.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports